import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MainComponent } from '@components/main/main.component';
import { ErrorResponse } from '@models/error.response';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { from, of } from 'rxjs';
import { LocaleSorterPipe } from "@pipes/locale-sorter.pipe";

import { TranslateService } from '@ngx-translate/core';
import { Setting, GeneralSetting } from '@models/setting';
import { SystemParameter } from "@models/system-parameter";
import swal from 'sweetalert2';
import { CommonService } from '@services/common.service';
import { mergeMap, reduce, switchMap } from 'rxjs/operators';
// import { CKEditor5 } from "@ckeditor/ckeditor5-angular";
import { UploadOutput, UploadFile } from "ngx-uploader";
import { I18nString } from '@app/models/i18n/i18n-string';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { BinaryFile } from '@app/models/binary-file';
import { ApplicationFile } from '@app/models/application-file';
import { SystemParameterService } from '@app/services/system-parameter.service';
import { ActionType } from '@app/types/action.type';


const MAX_HERO_FILE_SIZE: number = 10 * 1024 * 1024;



@Component({
    templateUrl: './system-parameter-setup.component.html',
    styleUrls: ['./system-parameter-setup.component.scss']
})
export class SystemParameterSetupComponent implements OnInit, AfterViewInit {

    isFieldError = FormValidationUtil.isFieldError;
    // @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    loading: boolean = false;
    clickedSave: boolean = false;
    record: SystemParameter;
    action: ActionType;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    systemParametersMap: Map<String, SystemParameter>;

    supportedFileType: string[] = ['image/jpeg', 'image/jpg', 'image/png'];

    tab: string = 'general';

    @ViewChild('generalSettingForm', { static: false }) generalSettingForm: NgForm;

    constructor(
        private router: Router,
        public appConstant: AppConstant,
        public commonService: CommonService,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        private route: ActivatedRoute,
        private systemParameterService: SystemParameterService
    ) {
    }

    ngOnInit(): void {
        
        this.record = new SystemParameter();
        let companyCode =  this.commonService.getCurrentUser().companyCode;
        
       

        // this.taskTypeOptions = [].concat(this.commonTaskTypeOptions)
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action,'PERM_SYSTEM_SETTING_SETUP');
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = this.commonService.showUpdateButton(this.action,'PERM_SYSTEM_SETTING_SETUP');
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new SystemParameter();
                        return of(form);
                    } else {
                        return this.systemParameterService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: SystemParameter) => {
                this.record = workflowForm;
                  
                this.loading = false;
            });
    }

    ngAfterViewInit(): void {

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.SETTING_PATH]);
    }

    getSettings(): void {
        this.loading = true;

        // this.systemParameterService.getAll().subscribe(setting => {
        //     if (setting != null) {
        //         this.setting = setting;
        //         this.systemParametersMap = new Map();
        //         if(this.setting.systemParameters && this.setting.systemParameters.length > 0){
        //             this.setting.systemParameters.forEach(param => {
        //                 this.systemParametersMap[param.code] = param;
        //             });
        //         }

        //         if (setting.generalSetting != null) {
        //             this.setting.generalSetting = setting.generalSetting;
        //             this.setting.generalSetting.address.i18nStrings = new LocaleSorterPipe<I18nString>().transform(this.setting.generalSetting.address.i18nStrings);
        //         } else {
        //             this.setting.generalSetting = new GeneralSetting();
        //         }
 

        //     }

        //     this.loading = false;
        // });
    }


    removeLetterImage(key: string): void {
        // this.letterInfoMap.set(key, null);
        // this.documentFileSelect.nativeElement.value = '';
    }



    public onLetterImageOutput(output: UploadOutput, key: string): void {
        if (output.file != null) {
            let imageFile = new ApplicationFile(output.file, this.supportedFileType, MAX_HERO_FILE_SIZE);
            // this.isImageFileValid = this.imageFile.isValid();
            imageFile.readAsBase64((data: string) => {
                let item = new BinaryFile()
                item.content = data;
                item.fileName = output.file.name;
                item.fileSize = output.file.size;

                // if (this.letterInfoMap.get(key) == null) {
                //     this.letterInfoMap.set(key, item);
                // } else {
                //     this.letterInfoMap.get(key).content = data;
                //     this.letterInfoMap.get(key).fileName = output.file.name;
                //     this.letterInfoMap.get(key).fileSize = output.file.size;
                // }
                output.type = null;
            })
        }
    }



    // getParamByCode(code: string) {
    //     return this.setting.systemParameters.find(x => x.code == code);
    // }



    refresh(): void {
        this.getSettings();
    }

    public save(): void {
        this.clickedSave = true;

        for (let key of Object.keys(this.generalSettingForm.controls)) {
            this.generalSettingForm.controls[key].markAsDirty();
        }
        // for (let key of Object.keys(this.letterInfoSettingForm.controls)) {
        //     this.letterInfoSettingForm.controls[key].markAsDirty();
        // }

        // Check if forms valid
        if (this.generalSettingForm.valid) {
            this.update();
        }
    }

    private update(): void {
        this.mainComponent.enableLoadingMask();
        this.loading = true;

        // let systemParameterList = [];
        // Object.keys(this.systemParametersMap).forEach(key => systemParameterList.push(this.systemParametersMap[key]));
        // this.setting.systemParameters = systemParameterList;

        // this.letterInfoMap.forEach((value, key) => {
        //     let keyStrList = key.split(this.contactLetterKeyFlag);
        //     this.setting.letterInfos.forEach(item => {
        //         if (item.itemType == keyStrList[0] && item.fileType == keyStrList[1]) {
        //             item.letterImage = value;
        //         }
        //     });
        // });

        this.systemParameterService.update(this.record)
            .subscribe(setting => {
                this.record = setting;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.SETTING_PATH]);
                this.refresh();

                this.translate.get(this.record.code)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;

                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.SETTING_PATH)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })
    }
}
